import {CART_ADD_ITEM, CART_LOAD_FROM_LOCAL_STORAGE, CART_REMOVE_ITEM, CART_TO_LOCAL_STORAGE} from "../utils/Constant";

const cart = function (state = {}, action) {
  switch (action.type) {
    case CART_ADD_ITEM:
      return {...state, [action.data.item.id]: action.data.item};
    case CART_REMOVE_ITEM:
      let newState = {...state};
      delete newState[action.data.id];
      return newState;
    case CART_TO_LOCAL_STORAGE:
      localStorage.setItem('cart', JSON.stringify(state));
      return state;
    case CART_LOAD_FROM_LOCAL_STORAGE:
      if(localStorage.hasOwnProperty('cart')) {
        return JSON.parse(localStorage.getItem('cart'))
      }
      return state;
    default :
      return state;
  }
}
export default cart;
